(() => {
  const gewoon = (t) => t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  const rustig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class VtSvKennis extends HTMLElement {
    connectedCallback() {
      this.onderwerpen = [...this.querySelectorAll('[data-onderwerp]')];
      this.status = this.querySelector('[data-status]');
      this.wis = this.querySelector('[data-wis]');
      this.leeg = this.querySelector('[data-leeg]');
      this.teksten = new Map();
      this.querySelectorAll('.vt-sv__vraag').forEach((v) => this.teksten.set(v, gewoon(v.textContent)));
      this.bouwIndex();
      this.wis.addEventListener('click', () => {
        document.querySelectorAll('vt-sv-zoek input[type="search"]').forEach((i) => { i.value = ''; });
        this.filter('');
        this.status.focus();
      });
    }

    bouwIndex() {
      const nav = this.querySelector('[data-index]');
      const lijst = this.querySelector('[data-index-lijst]');
      if (!nav || !this.onderwerpen.length) return;
      this.onderwerpen.forEach((o) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${o.id}`;
        a.textContent = o.dataset.kort;
        const n = document.createElement('span');
        n.className = 'vt-svk__n';
        n.setAttribute('aria-hidden', 'true');
        a.append(n);
        li.append(a);
        lijst.append(li);
        o.indexRegel = { li, n };
      });
      this.tel();
      nav.hidden = false;
    }

    tel() {
      this.onderwerpen.forEach((o) => {
        if (!o.indexRegel) return;
        const n = o.querySelectorAll('.vt-sv__vraag:not([hidden])').length;
        o.indexRegel.n.textContent = n;
        o.indexRegel.li.hidden = n === 0;
      });
    }

    filter(term, naarVragen) {
      const woorden = gewoon(term).split(/\s+/).filter((w) => w.length > 1);
      let totaal = 0;
      this.onderwerpen.forEach((o) => {
        let hier = 0;
        o.querySelectorAll('.vt-sv__vraag').forEach((v) => {
          const raak = woorden.every((w) => this.teksten.get(v).includes(w));
          v.hidden = !raak;
          v.open = woorden.length ? raak : v.hasAttribute('data-open');
          if (raak) hier += 1;
        });
        o.hidden = hier === 0;
        totaal += hier;
      });
      this.tel();

      const zoekt = woorden.length > 0;
      let sjabloon = this.dataset.statusMeer;
      if (totaal === 0) sjabloon = this.dataset.leegKop;
      else if (totaal === 1) sjabloon = this.dataset.statusEen;
      this.status.textContent = zoekt ? sjabloon.replace('[n]', totaal).replace('[term]', term.trim()) : '';
      this.wis.hidden = !zoekt;
      this.leeg.hidden = !(zoekt && totaal === 0);
      if (zoekt && totaal === 0) {
        this.leeg.querySelector('[data-leeg-kb]').href = this.dataset.kennisbank + encodeURIComponent(term.trim());
      }

      if (naarVragen) {
        this.scrollIntoView({ behavior: rustig() ? 'auto' : 'smooth', block: 'start' });
        this.status.focus({ preventScroll: true });
      }
    }
  }

  class VtSvZoek extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('form');
      const veld = this.querySelector('input[type="search"]');
      if (!form || !veld) return;
      const vragen = () => document.querySelector('vt-sv-kennis');

      form.addEventListener('submit', (e) => {
        const k = vragen();
        if (!k) return;
        e.preventDefault();
        k.filter(veld.value, true);
      });
      veld.addEventListener('input', () => {
        const k = vragen();
        if (k) k.filter(veld.value, false);
      });
      this.addEventListener('click', (e) => {
        const chip = e.target.closest('[data-zoek]');
        const k = vragen();
        if (!chip || !k) return;
        e.preventDefault();
        veld.value = chip.dataset.zoek;
        k.filter(veld.value, true);
      });
    }
  }

  if (!customElements.get('vt-sv-kennis')) customElements.define('vt-sv-kennis', VtSvKennis);
  if (!customElements.get('vt-sv-zoek')) customElements.define('vt-sv-zoek', VtSvZoek);
})();
